import React, { useEffect, useState, useCallback, Suspense, useLayoutEffect } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { QueryHookParam, useQueryDummyHook } from '@utils/hook/useQueryHook';
import { CreateAsoOption } from '@classes/options/chart/aso/aso';
import { PieChartDataModel } from '@models/highChartsModel';
import { ScoreBarType } from '@models/aso/aso';
import { gameProviderTypes } from '@configs/layout';
import { OptimizationTabObjList } from '@models/keyword/keyword';
import { optimizationTabType } from '@models/keyword/keywordModel';
import { fetchKeywordGroupList, fetchReqKeywordList } from '@reducers/keywordSlice';
import Description from '../../components/template/app/app/description';
import KeywordOptimizationDescription from '@components/template/keyword/optimization/description/index';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));
const TabSelector = React.lazy(() => import('@components/template/keyword/optimization/tabSelector'));
const KeywordOptimization = React.lazy(() => import('@components/template/keyword/optimization/index'));
// const KeywordOptimizationDescription = React.lazy(
//   () => import('@components/template/keyword/optimization/description/index')
// );

type Props = {};

const Optimization = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();

  // TODO: 검색창에서 검색한 App 존재시 그걸로 대체해야한다.(없을땐 myAppObj 넣기)
  const { myAppObj } = useSelector(({ LAYOUT }: RootState) => LAYOUT);
  const { keywordGroupList } = useSelector(({ keyword }: RootState) => keyword);

  // useState
  const [selectedTab, setSelectedTab] = useState<optimizationTabType>(OptimizationTabObjList[0]);

  // useEffect  keywordGroupList 가 없을때 요청처리
  useLayoutEffect(() => {
    if (!keywordGroupList) {
      dispatch(fetchKeywordGroupList({ email: 'ss' }));
      dispatch(fetchReqKeywordList({ email: 'ss' }));
    }
  }, [keywordGroupList]);

  // useCallback
  const handleCheck = useCallback(
    (value) => {
      const selectedObj = OptimizationTabObjList.find((item) => item.value === value);
      setSelectedTab(selectedObj);
    },
    [setSelectedTab, OptimizationTabObjList]
  );

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <div className="box-container">
        <div className="chart-tab">
          {/* 탭 선택 */}
          <Suspense fallback={<LoaderComponent />}>
            <TabSelector
              tabObjectArr={OptimizationTabObjList}
              currentState={selectedTab.value}
              onCheck={handleCheck}
              pageName={'Keyword Optimization'}
            />
          </Suspense>
          {/* 분석 컴포넌트 부분 TODO: selectedTab 값만 받아서 여기서 url 및 나머지 처리 */}
          <Suspense fallback={<LoaderComponent />}>
            {selectedTab.value !== OptimizationTabObjList[3].value ? (
              <KeywordOptimization
                selectedTab={selectedTab.value}
                tabTitle={selectedTab.title}
                tabText={selectedTab.text}
                limitLength={selectedTab.limitLength}
                selectedGameInfo={myAppObj}
                groupList={keywordGroupList}
              />
            ) : (
              // <DescriptionComponent selectedGameInfo={selectedGameInfo} groupList={groupList} />
              <KeywordOptimizationDescription
                selectedTab={selectedTab.value}
                tabTitle={selectedTab.title}
                tabText={selectedTab.text}
                limitLength={selectedTab.limitLength}
                selectedGameInfo={myAppObj}
              />
            )}
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default Optimization;
